import React from 'react';
import UsersDetails from 'components/users/Details';
import CompaniesDetails from 'components/companies/Details';
import RecruitersDetails from 'components/recruiters/Details';

import {Button} from 'react-bootstrap'

export default props => {
  return (
    <div>
      <Button bsStyle="danger" className="pull-right" onClick={props.selectOne()}>Close</Button>
      <h2>Indepth: Recruiter</h2>

      <RecruitersDetails {...props} />
      <UsersDetails.Container userId={props.selected.user} />
      {/* <CompaniesDetails company={props.selected.company} /> */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/recruiters/Indepth.jsx